var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg002BAuenbereich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.6670000000001,
    height: 451.6670000000001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 429.613716,
    height: 429.613716,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_8",
    height: 0,
    width: 1.667895,
    y: 432.826259,
    x: 621.959231,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_10",
    height: 0,
    width: 0.833948,
    y: 286.051457,
    x: 641.973996,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: -58.536738,
    y: -14.998601,
    width: 631.28522,
    height: 484.513481,
    id: "svg_6",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.187174,302.297442c-1.586779,-11.902545 -6.859013,-22.847803 -15.058477,-31.128742c-9.066857,-9.156651 -20.887045,-14.199582 -33.283512,-14.199582c-12.396467,0 -24.216656,5.04293 -33.283863,14.199582c-8.199464,8.280939 -13.471348,19.226197 -15.058477,31.128742c-17.661003,8.362515 -29.308344,27.439599 -29.308344,48.557606c0,29.207716 21.912941,52.969553 48.84724,52.969553c8.301284,0 16.391231,-2.288688 23.554304,-6.566699l0,53.976545l10.496882,0l0,-53.976545c7.163072,4.278011 15.253019,6.566699 23.554304,6.566699c26.934649,0 48.84724,-23.762216 48.84724,-52.969553c0.00105,-21.118007 -11.646289,-40.195469 -29.307294,-48.557606l-0.000001,0l-0.000002,0zm-19.539246,90.144425c-8.563356,0 -16.840497,-3.100277 -23.554303,-8.773053l0,-34.812194l23.540657,-13.422141l-4.885249,-10.074859l-18.655408,10.636786l0,-22.405773l-10.496882,0l0,47.634845l-18.655408,-10.636786l-4.885249,10.074858l23.540657,13.422141l0,9.583124c-6.713805,5.672776 -14.990947,8.773053 -23.554303,8.773053c-21.146669,0 -38.350358,-18.655921 -38.350358,-41.586819c0,-17.533585 10.226062,-33.275525 25.44619,-39.172161l3.210647,-1.243754l0.256823,-3.686488c0.727085,-10.422411 5.027657,-20.101529 12.109903,-27.25406c7.117235,-7.188197 16.397179,-11.146731 26.129538,-11.146731s19.012303,3.958535 26.129889,11.146353c7.082246,7.152531 11.382819,16.83127 12.109902,27.254059l0.256823,3.686489l3.210647,1.243754c15.220129,5.896635 25.44619,21.638578 25.44619,39.172161c0,22.931276 -17.204039,41.587198 -38.350707,41.587198l0.000002,-0.000001l-0.000001,-0.000001z",
    id: "svg_9",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_13",
    height: 60.878189,
    width: 192.606431,
    y: 292.783475,
    x: 293.969743,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#ffffff",
    transform: "matrix(0.9189777431505346,-0.6339962966754117,0.6434751432009508,0.9054405473788716,-122.32393257533431,90.72550959300548) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_12",
    height: 253.493572,
    width: 343.35658,
    y: 182.422419,
    x: 342.535066,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "matrix(-0.8718526026241852,-0.6956122533313539,0.706012316904577,-0.8590095936898282,404.1899149876019,487.34757531791496) ",
    id: "svg_14",
    height: 60.878189,
    width: 192.606431,
    y: 313.160283,
    x: -20.754692,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m692.094772,239.984645c-6.005236,0 -10.875768,4.554822 -10.875768,10.170797l0,181.20124l-116.704238,0l0,-113.746813c0,-5.615977 -4.870532,-10.170797 -10.875768,-10.170797l-85.193514,0c-6.005236,0 -10.875768,4.554822 -10.875768,10.170797l0,90.192941c0,5.615977 4.870532,10.170797 10.875768,10.170797s10.875768,-4.554822 10.875768,-10.170797l0,-80.022143l63.441979,0l0,103.576015l-201.899563,0l0,-248.948926l170.176761,-127.540111l174.25155,130.593046c4.687456,3.51401 11.53194,2.805445 15.287704,-1.576473c3.755765,-4.383613 3.001712,-10.782741 -1.685744,-14.296751l-181.052529,-135.692005c-3.973281,-2.980043 -9.628678,-2.980043 -13.60196,0l-181.052529,135.692005c-2.575745,1.930756 -4.074788,4.848081 -4.074788,7.936613l0,264.001707c0,5.615977 4.86872,10.170797 10.875768,10.170797l362.106871,0c6.007048,0 10.875768,-4.554822 10.875768,-10.170797l0,-191.370344c0,-5.617671 -4.86872,-10.170797 -10.875768,-10.170797l-0.000001,-0.000003l0.000001,0.000002z",
    id: "svg_1",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_15",
    height: 73.917743,
    width: 181.501853,
    y: 123.427551,
    x: 418.316755,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#ffffff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m667.6089,338.913467l-8.506604,0c-3.962882,0 -7.190413,3.156247 -7.190413,7.034402l0,1.441018c-9.599615,0.794658 -17.167717,8.676882 -17.167717,18.265941l0,6.835738l-34.049305,0c-4.889939,0 -8.869987,3.892146 -8.869987,8.674083l0,41.691562l5.722572,0l0,8.394275l17.167717,0l0,-8.394275l37.196721,0l0,8.394275l17.167717,0l0,-8.394275l5.722572,0l0,-44.769463l0,-5.596182l0,-26.542695c0,-3.878154 -3.227531,-7.034402 -7.193274,-7.034402l-0.000001,0l0.000002,-0.000001l0,-0.000001zm-27.142161,26.74136c0,-6.502765 5.00439,-11.883495 11.445145,-12.652969l0,19.488707l-11.445145,0l0,-6.835738zm-31.474148,59.999475l-5.722572,0l0,-2.798092l5.722572,0l0,2.798092zm54.364438,0l-5.722572,0l0,-2.798092l5.722572,0l0,2.798092zm5.722572,-8.394275l-17.167717,0l-37.196721,0l-17.167717,0l0,-36.095379c0,-1.695643 1.410614,-3.077901 3.147415,-3.077901l34.049305,0l17.167717,0l5.722572,0l11.445145,0l0,39.17328l0.000001,0zm-11.445145,-44.769463l0,-25.182823l0,-1.359873c0,-0.794658 0.658096,-1.438219 1.470701,-1.438219l8.506604,0c0.809745,0 1.46784,0.643561 1.46784,1.438219l0,26.542695l-11.445145,0l0,0.000001z",
    id: "svg_3",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_11",
    points: "374.28342366218567,324.9032897949219 374.28342366218567,324.9035339355469 374.2837288379669,324.9032897949219 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 112.418982,
    cy: 328.997634,
    id: "svg_17",
    rx: 54.205467,
    ry: 53.788505,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.18259,277.36288c-1.961689,-13.895232 -8.479601,-26.67291 -18.616364,-36.340218c-11.209095,-10.689629 -25.822056,-16.576831 -41.147453,-16.576831c-15.325397,0 -29.938358,5.887202 -41.147886,16.576831c-10.136763,9.667308 -16.654242,22.444986 -18.616364,36.340218c-21.833793,9.762541 -36.233066,32.033449 -36.233066,56.686967c0,34.09758 27.090341,61.837548 60.388443,61.837548c10.262639,0 20.264009,-2.671854 29.119511,-7.666075l0,63.013128l12.976994,0l0,-63.013128c8.855501,4.994221 18.85687,7.666075 29.119511,7.666075c33.298535,0 60.388443,-27.740411 60.388443,-61.837548c0.001298,-24.653517 -14.397975,-46.924868 -36.231768,-56.686967l-0.000001,0zm-24.155809,105.23612c-10.586633,0 -20.819424,-3.619316 -29.119511,-10.241809l0,-40.640343l29.102641,-15.669233l-6.039494,-11.761559l-23.063147,12.417563l0,-26.156878l-12.976994,0l0,55.60972l-23.063147,-12.417563l-6.039494,11.761559l29.102641,15.669233l0,11.1875c-8.300086,6.622494 -18.532878,10.241809 -29.119511,10.241809c-26.143021,0 -47.411449,-21.779237 -47.411449,-48.549153c0,-20.469002 12.642188,-38.846409 31.458397,-45.730241l3.96923,-1.451979l0.317503,-4.303668c0.898874,-12.167298 6.215548,-23.466863 14.971125,-31.816848c8.798835,-8.391622 20.271363,-13.012883 32.303199,-13.012883s23.504365,4.621261 32.303633,13.01244c8.755578,8.349985 14.072253,19.649108 14.971125,31.816848l0.317503,4.303668l3.96923,1.451979c18.816209,6.883832 31.458397,25.26124 31.458397,45.730241c0,26.770358 -21.268861,48.549596 -47.411881,48.549596l0.000002,-0.000001l0.000002,0.000002z",
    id: "svg_4",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    id: "svg_5",
    d: "m194.235035,212.320398l86.502873,-47.834222c1.703353,-0.940912 3.772301,-0.174152 4.621752,1.714723l18.454581,41.037728c0.407877,0.907069 0.474002,1.956561 0.184068,2.917568c-0.289932,0.961359 -0.912079,1.755265 -1.730375,2.207565l-25.827514,14.281487l2.291483,5.095873c0.849133,1.888875 0.157047,4.183163 -1.546307,5.125133l-0.814164,0.450538l4.450082,8.788309l26.239522,0c2.440265,-5.233713 7.362758,-8.814044 13.042828,-8.814044l0,32.552245c-5.548773,0 -10.377166,-3.415345 -12.872111,-8.45305l-30.444815,0c-2.491766,0 -4.78929,-1.490864 -6.009422,-3.900079l-6.757143,-13.343396l-1.174671,0.649367c-1.703035,0.941617 -3.772619,0.173799 -4.62207,-1.714371l-2.291483,-5.095873l-19.297039,10.671544c-1.112997,0.615524 -2.438675,0.518577 -3.468698,-0.254882l-5.32592,-3.99491l-9.509275,5.258391c-0.482585,0.26722 -1.009042,0.401888 -1.537723,0.401888c-0.368456,0 -0.737547,-0.066276 -1.093287,-0.198124c-0.866936,-0.320806 -1.582866,-1.011419 -1.990742,-1.918135l-9.735627,-21.650144l-10.095816,-7.369009c-1.029705,-0.751602 -1.618789,-2.055976 -1.545034,-3.420281c0.073755,-1.36501 0.799221,-2.581603 1.902046,-3.191839l-0.000001,0l0.000002,0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_34"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_2",
    d: "m479.43964,277.705246l-94.952481,0c-1.955678,0 -3.541542,1.420402 -3.541542,3.172034l0,152.895209c0,1.751632 1.585863,3.172034 3.541542,3.172034l94.952829,0c1.955678,0 3.541542,-1.420402 3.541194,-3.172034l0,-152.895209c0,-1.751632 -1.585863,-3.172034 -3.541542,-3.172034zm-3.541542,152.895209l-87.869398,0l0,-146.551141l87.869051,0l0,146.551141l0.000347,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_7",
    d: "m423.817749,292.296789l-23.37473,0c-1.955678,0 -3.541542,1.420402 -3.541542,3.172034l0,61.237454c0,1.751632 1.585863,3.172034 3.541542,3.172034l23.37473,0c1.955678,0 3.541542,-1.420402 3.541542,-3.172034l0,-61.237143c0.000347,-1.751632 -1.585863,-3.172345 -3.541542,-3.172345zm-3.541542,61.237454l-16.291299,0l0,-54.893075l16.291299,0l0,54.893075z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_16",
    d: "m463.483778,292.296789l-23.37473,0c-1.955678,0 -3.541542,1.420402 -3.541542,3.172034l0,61.237454c0,1.751632 1.585863,3.172034 3.541542,3.172034l23.37473,0c1.955678,0 3.541542,-1.420402 3.541542,-3.172034l0,-61.237143c0.000347,-1.751632 -1.585863,-3.172345 -3.541542,-3.172345zm-3.541542,61.237454l-16.291299,0l0,-54.893075l16.291299,0l0,54.893075z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_18",
    d: "m403.453625,365.905455c-4.979826,0 -9.031122,3.628603 -9.031122,8.088858s4.051296,8.088858 9.031122,8.088858s9.031122,-3.628603 9.031122,-8.088858s-4.051296,-8.088858 -9.031122,-8.088858zm0,9.833336c-1.073678,0 -1.948039,-0.782823 -1.948039,-1.74479s0.874013,-1.74479 1.948039,-1.74479s1.948039,0.782823 1.948039,1.74479s-0.87436,1.74479 -1.948039,1.74479z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_19",
    d: "m463.483778,392.86821c-1.955678,0 -3.541542,1.420402 -3.541542,3.172034l0,25.376894c0,1.751632 1.585863,3.172034 3.541542,3.172034c1.955678,0 3.541542,-1.420402 3.541542,-3.172034l0,-25.376894c0.000347,-1.751632 -1.585863,-3.172034 -3.541542,-3.172034z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_20",
    d: "m463.483778,381.448702c-1.955678,0 -3.541542,1.420402 -3.541542,3.172034l0,1.586172c0,1.751632 1.585863,3.172034 3.541542,3.172034c1.955678,0 3.541542,-1.420402 3.541542,-3.172034l0,-1.586172c0.000347,-1.751632 -1.585863,-3.172034 -3.541542,-3.172034z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002BAuenbereich);
export default __webpack_public_path__ + "static/media/002b-Außenbereich.73a9cf991cac19812148b1c488b0b461.svg";
export { ForwardRef as ReactComponent };